/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Italicize_Event_TextInputs */

const en_italicize_event_text = /** @type {(inputs: Italicize_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Italicize event text`)
};

const fr_italicize_event_text = /** @type {(inputs: Italicize_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texte d'événement en italique`)
};

const de_italicize_event_text = /** @type {(inputs: Italicize_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignistext kursiv darstellen`)
};

const it_italicize_event_text = /** @type {(inputs: Italicize_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metti in corsivo il testo dell'evento`)
};

const ru_italicize_event_text = /** @type {(inputs: Italicize_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выделить текст события курсивом`)
};

const es_italicize_event_text = /** @type {(inputs: Italicize_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poner en cursiva el texto del evento`)
};

const zh_cn2_italicize_event_text = /** @type {(inputs: Italicize_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将事件文本斜体化`)
};

const ja_italicize_event_text = /** @type {(inputs: Italicize_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントテキストを斜体にする`)
};

const hi_italicize_event_text = /** @type {(inputs: Italicize_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट टेक्स्ट को इटैलिक करें`)
};

const pt_pt2_italicize_event_text = /** @type {(inputs: Italicize_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texto do evento em itálico`)
};

/**
* | output |
* | --- |
* | "Italicize event text" |
*
* @param {Italicize_Event_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const italicize_event_text = /** @type {((inputs?: Italicize_Event_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Italicize_Event_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_italicize_event_text(inputs)
	if (locale === "de") return de_italicize_event_text(inputs)
	if (locale === "it") return it_italicize_event_text(inputs)
	if (locale === "ru") return ru_italicize_event_text(inputs)
	if (locale === "es") return es_italicize_event_text(inputs)
	if (locale === "zh-CN") return zh_cn2_italicize_event_text(inputs)
	if (locale === "ja") return ja_italicize_event_text(inputs)
	if (locale === "hi") return hi_italicize_event_text(inputs)
	if (locale === "pt-PT") return pt_pt2_italicize_event_text(inputs)
	return en_italicize_event_text(inputs)
});